// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fixed-height > *[data-v-e684e6f2] {\n  height: 100%;\n}\n.fixed-height .m-content[data-v-e684e6f2] {\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
